module.exports = __webpack_public_path__ + "img/button_press down_02.d9f3a0b8.png";